const mapStyles = [
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#444444"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"lightness": "13"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "geometry",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "simplified"
			},
			{
				"lightness": "13"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "geometry",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
			{
				"color": "#f7f7eb"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "landscape.man_made",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.natural.landcover",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.natural.terrain",
		"elementType": "all",
		"stylers": [
			{
				"lightness": "-5"
			},
			{
				"gamma": "1.00"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#46bcec"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#b9e0e2"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	}
];
const colors = {
	marker: '#acb439',
	label: '#ffffff'
}

var zoomFactor = 7
if ($(window).outerWidth() > 991) {
    zoomFactor = 8
}

const googlemaps = {
	apiKey: window.speciesmapConfig.googlemaps.apiKey,
	mapOptions: {
		center: {
			lat: 46.8352186,
			lng: 8.1718753
		},
		mapTypeId: 'roadmap',
		styles : mapStyles,
		mapTypeControl: 0,
		streetViewControl: 0,
		rotateControl: 0,
		fullscreenControl: 0,
		zoom: zoomFactor
	},
	marker: {
		label: {
			color: colors.label
		},
		icon: {
			fillOpacity: 1,
			fillColor: colors.marker,
			strokeOpacity: 0,
			strokeWeight: 0,
			scale: 20
		}
	},
	cluster: {
		styles: [{
			textColor: colors.label,
			width: 48,
			height: 48,
			url: createInlineSVG()
		}],
		maxZoom: zoomFactor
	}
}

// filter : [subfilters]
const filterHierarchy = {
	visit: ['visit-type'],
	product: ['product-type'],
	seal: ['animals', 'plants'],
	animals: ['animal-type'],
	plants: ['plant-type'],
}

const subButtons = ['animals', 'plants']

// filter : search field in location
const filterKeys = {
	'visit': ['visit'],
	'visit-type': ['visit'],
	'product': ['product'],
	'product-type': ['product'],
	'seal': ['seal', 'conservation'],
	'animals': ['seal', 'conservation'],
	'plants': ['seal', 'conservation'],
	'animal-type': ['seal', 'conservation'],
	'plant-type': ['seal', 'conservation']
}

const filterDefaults = {
	'animal-type': /race-\d+/,
	'plant-type': /seal-\d+/
}


function createInlineSVG() {
	return 'data:image/svg+xml;base64,' + window.btoa(`<svg version="1.1" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(-847 -2398)" fill="${colors.marker}"><g transform="translate(847 2398)"><circle cx="24" cy="24" r="20" opacity=".5"/><circle cx="24" cy="24" r="24" opacity=".5"/><path d="m24 40c8.8366 0 16-7.1634 16-16 0-5.4718-2.7467-10.302-6.9366-13.187-2.5765-1.7742-5.6986-2.8128-9.0634-2.8128-8.8366 0-16 7.1634-16 16s7.1634 16 16 16z"/></g></g></g></svg>`);
}


module.exports = {
	colors,
	filterHierarchy,
	subButtons,
	filterKeys,
	filterDefaults,
	...window.speciesmapConfig,
	googlemaps
}
